import { render, staticRenderFns } from "./VideoCategory.vue?vue&type=template&id=03f2612a&scoped=true&"
import script from "./VideoCategory.vue?vue&type=script&lang=js&"
export * from "./VideoCategory.vue?vue&type=script&lang=js&"
import style0 from "./VideoCategory.vue?vue&type=style&index=0&id=03f2612a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f2612a",
  null
  
)

export default component.exports